import { inject, Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { PermissionService, RemoveMenuItemByProperty } from '@cv-invision/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PERMISSION } from '../../inbox/model/permission.model';

@Injectable({ providedIn: 'root' })
export class InboxLoaderGuard implements CanActivate {
    constructor(
        private router: Router,
        private store: Store,
        private userPermission: PermissionService,
    ) {}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        // Validate if the user has the queues manager permission to interact with the queue manager
        if (!this.userPermission.hasPermission(PERMISSION.QUEUES_MANAGER)) {
            this.store.dispatch(
                new RemoveMenuItemByProperty({
                    property: 'value',
                    value: 'cv-manage-queues',
                }),
            );
        }
        return true;
    }
}
